import { Breadcrumbs } from "components/breadcrumbs";
import CreateFipixForm from "./components/createFipixForm";

export const CreateFipixAccount: React.FC = () => {
  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Create new Fipix Account" />
      <CreateFipixForm />
    </div>
  );
};
